import { render, staticRenderFns } from "./BookStoreDetail.vue?vue&type=template&id=49beb741&scoped=true"
import script from "./BookStoreDetail.vue?vue&type=script&lang=js"
export * from "./BookStoreDetail.vue?vue&type=script&lang=js"
import style0 from "./BookStoreDetail.vue?vue&type=style&index=0&id=49beb741&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49beb741",
  null
  
)

export default component.exports